import React, { useDebugValue, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "./ProductionLine.css";
import { ProductionLineImages } from "../../config/images";
import QrCodeStation from "./QRCodeStation";
import { toast } from "react-toastify";

const ProductionLine = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [scanStation, setScanStation] = useState();
  const [batchAssign, setBatchAssign] = useState(false);
  const[trayQrScan,setTrayQrScan]=useState(false)

  useEffect(() => {
    // Check if scanStation is passed in the state
    if (location?.state?.scanStation !== undefined) {
      setScanStation(location.state.scanStation); // Set scanStation to the passed value
    }
  }, [location]); // Re-run when location changes

  //   useEffect(() => {
  //     localStorage.removeItem("scanStation");
  // }, [scanStation]);

  const handleTrayScan = () => {
    setLoading(true); // Show loader

    setTimeout(() => {
      setLoading(false); // Hide loader after completion
      setScanStation(true);
    }, 3000);
  };

  const handleStationScan = () => {
    // navigate("/production-line-stripping");
    setBatchAssign(true);
  };
  const handleProductionLineClick = () => {
    if(trayQrScan){
      const batchId = JSON.parse(localStorage.getItem("batch_id"));
    
      navigate(`/production-line-chart`, {
        state: {
          batch_types: batchId,

         
        },
      });
    }
    else{
      navigate("/select-batch");
    }
   
  };

  return (
    <div className="min-h-screen bg-[#f5f3ff] p-8 dashboard-wrapper page-wraper">
      <div className="page-header">
        <Link to="/dashboard" className="page-back-btn">
          <ArrowBackIcon />
          <span>Production Line</span>
        </Link>
        {/* {batchAssign && ( */}
        {/* {scanStation &&  <> */}
        <div className="header-btn-group">
          <img
            src={ProductionLineImages.productionLineIcon}
            alt=""
            onClick={handleProductionLineClick}
            style={{ cursor: "pointer" }}
          />
        </div>

        {/* )} */}
      </div>

      <div
        className="pt-4 procution-line-title"
        style={{ fontSize: "36px", color: "#222D39" }}
      >
        {scanStation ? "Scan a Station" : "Scan a Tray"}
      </div>
      <div className="production-line-scanner">
        <QrCodeStation
          scanType={scanStation ? "station" : "tray"}
          setScanStation={setScanStation}
          setTrayQrScan={setTrayQrScan}
        />

        {/* )} */}
      </div>
      {loading && (
        <div className="pt-5">
          <span className="loader"></span>
        </div>
      )}
    </div>
  );
};
export default ProductionLine;
